export default __webpack_public_path__ + "media/images/home/slide_hiruobi_2026_lg-6de99378da7086ccbe7e0bf7ca1b38c0.jpg";